// Domain value sets shared by the database enums, Zod schemas and the client.

export const PRODUCT_TYPES = ["course", "ebook", "webinar", "workflow", "private"] as const;
export type ProductType = (typeof PRODUCT_TYPES)[number];

export const PRODUCT_STATUSES = ["draft", "active", "inactive"] as const;
export type ProductStatus = (typeof PRODUCT_STATUSES)[number];

/** File-backed types are served through presigned S3 URLs; `link` opens an external URL. */
export const PRODUCT_CONTENT_TYPES = ["video", "pdf", "json", "text", "zip", "link"] as const;
export type ProductContentType = (typeof PRODUCT_CONTENT_TYPES)[number];

export const PRODUCT_CONTENT_STATUSES = ["active", "inactive"] as const;
export type ProductContentStatus = (typeof PRODUCT_CONTENT_STATUSES)[number];

export const PRODUCT_GRANT_SOURCES = ["purchase", "admin"] as const;
export type ProductGrantSource = (typeof PRODUCT_GRANT_SOURCES)[number];

export const COUPON_DISCOUNT_TYPES = ["fixed", "percentage"] as const;
export type CouponDiscountType = (typeof COUPON_DISCOUNT_TYPES)[number];

export const COUPON_STATUSES = ["active", "inactive"] as const;
export type CouponStatus = (typeof COUPON_STATUSES)[number];

export const INVOICE_STATUSES = ["pending", "paid", "failed", "expired"] as const;
export type InvoiceStatus = (typeof INVOICE_STATUSES)[number];

/**
 * New invoices are always `doit`. `sumopod` (2026-09 to 2026-10) and `xendit_legacy` (migrated from
 * v1) only mark historical rows; Postgres cannot drop an enum value without rewriting the type.
 */
export const PAYMENT_GATEWAYS = ["sumopod", "xendit_legacy", "doit"] as const;
export type PaymentGateway = (typeof PAYMENT_GATEWAYS)[number];

export const ARTICLE_STATUSES = ["draft", "published"] as const;
export type ArticleStatus = (typeof ARTICLE_STATUSES)[number];

export const WEBHOOK_PROVIDERS = ["sumopod", "doit"] as const;
export type WebhookProvider = (typeof WEBHOOK_PROVIDERS)[number];
